import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditorContainer } from './containers/editor/editor.container';
import { FormulaEditorContainer } from './containers/formula-editor/formula-editor.container';
import { PlayerContainer } from './containers/player/player.container';
import { EditorDeactivateGuard } from './services/EditorDeactivateGuard';
import { DemoContainer } from './containers/demo/demo.container';


const routes: Routes = [
  {
      path: "",
      redirectTo: "/player",
      pathMatch: "full",
  }, {
    path: "formula-editor",
    component: FormulaEditorContainer,
  }, {
    path: "player",
    component: PlayerContainer,
  }, {
    path: "player/:id",
    component: PlayerContainer,
  }, {
    path: "demo/:id",
    component: DemoContainer,
  }, {
    path: "editor",
    component: EditorContainer,
    canDeactivate: [EditorDeactivateGuard]
  }, {
    path: "editor/:id",
    component: EditorContainer
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
